import { render, staticRenderFns } from "./FormAdditionalInfo.vue?vue&type=template&id=98384c90&"
import script from "./FormAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./FormAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports